
// ref: https://gitlab.com/web-apps-dietela/backend/-/merge_requests/252

export const reqUploadImageContentAndChallenge = async(axios, file) => {
  let formData = new FormData()
  formData.append('file', file)
  return axios.post('v1/admin/content-and-challenge/upload', formData)
}